import { MessageInputWithFilesUpload } from '@app/components/MessageInputWithFilesUpload/MessageInputWithFilesUpload.main';

export { MessageInputWithFilesUpload };
